export enum EProposalStatus {
  Active = 'Active',
  Closed = 'Closed',
  Pending = 'Pending',
}

export enum EProposalTags {
  Economy = 'Economy',
  TokenPGX = 'PGX',
  TokenVIS = 'VIS',
  TokenPega = 'Pega',
  Gameplay = 'Gameplay',
  Other = 'Other',
}

export interface IProposalComment {
  text: string;
  date: Date;
  publicAddress: string;
  userTag?: string;
}

export interface IProposalVote {
  voteOption: string;
}

export interface IProposalVoter {
  userId: string;
  publicAddress: string;
  netWorth: number;
  voteOption: string;
  userTag?: string;
}

export interface IProposalSnapshotUser {
  userId: string;
  publicAddress: string;
  netWorth: number;
  userTag?: string;
}

export interface IProposalSnapshot {
  date: Date;
  blockNumber: number;
  users: [IProposalSnapshotUser];
}

export interface IProposalResult {
  key: string;
  percentage: number;
  totalNetWorth: number;
  numberOfVotes: number;
}

export interface IProposal {
  _id: string;
  voteOptions: string[];
  votes: number;
  voters?: [IProposalVoter];
  comments?: [IProposalComment];
  results?: IProposalResult[];
  snapshot?: IProposalSnapshot;
  submissionId?: string;
  status: EProposalStatus;
  outcome?: string;
  tags: [EProposalTags];
  title: string;
  summary: string;
  problem: string;
  appetite?: string;
  solution: string;
  rabbitHoles?: string;
  noGos?: string;
  createdBy: string;
  creatorAddress: string;
  startDate: Date;
  endDate: Date;
  feedback: string;
}
